__turbopack_context__.v({
  "container": "ComingSoon-module__UyXV4q__container",
});
